import { createComponent } from '../core/create-component.js';
import { SWAN_STYLE_KEY_MAP } from '../head/stylesheets.component.js';
var Progress = createComponent({
  displayName: 'Progress',
  root: 'progress',
  requiredStyleKeys: SWAN_STYLE_KEY_MAP.progressBar,
  propConfig: {
    classNames: ['swan-progress']
  }
});
Progress.defaultProps = {
  max: 100
};
export { Progress };